import type { MotionSkin } from "./types";

export const coolSkin: MotionSkin = {
  id: "cool",
  label: "クール",
  palette: {
    backgroundTop: "#0a1020",
    backgroundBottom: "#13182d",
    foreground: "#f4f8ff",
    muted: "#98a2b8",
    up: "#22eb9c",
    down: "#ff4052",
    grid: "rgba(120,132,170,.17)",
    card: "rgba(15,22,42,.86)",
    panel: "rgba(8,12,26,.78)",
    accent: "#ffe178"
  },
  typography: { family: "system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif", titleWeight: 800 },
  decoration: "neon",
  upEffect: "surge-light",
  downEffect: "cracks"
};
